import { CommitmentKpi, GoalStatus } from '../../coaching-base/general';

import { GoalFormValue } from './goals.commitment.form';

// TODO maybe find a way for this to be callable from goals.commitment.component
export function pendingCloseAllGoals(
    commitmentKpis: CommitmentKpi[],
): CommitmentKpi[] {
    const current = commitmentKpis || [];
    const next: CommitmentKpi[] = [];

    current.forEach((e) => {
        if (!e.isOriginalGoal) {
            e.statusId = GoalStatus.PENDING_CLOSE;
            next.push(e);
            return;
        }

        next.push(e);

        // shouldn't be needed, but maybe for old data
        if (e.statusId === GoalStatus.PENDING_CLOSE) {
            return;
        }

        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const nextGoal = {
            ...e,
            statusId: GoalStatus.PENDING_CLOSE,
            isOriginalGoal: undefined,
            diffItemId: undefined,
            tracking_id: Math.random(),
        } as GoalFormValue;

        next.push(nextGoal);
    });

    return next;
}
